import service from 'service';

export const getMaskNamesList = ({ queryKey: [, params] }) => {
  const url = '/core_sender/v1/sender_name';
  return service.get(url, { params });
};

export const updateMaskName = ({ uuid, payload }) => {
  const url = `/core_sender/v1/sender_name/${uuid}`;
  return service.put(url, payload);
};

export const updateActiveMaskName = ({ uuid, payload }) => {
  const url = `/core_sender/v1/sender_name/deactivate/${uuid}`;
  return service.put(url, payload);
};

export const deleteMaskName = (uuid) => {
  const url = `/core_sender/v1/sender_name/${uuid}`;
  return service.delete(url);
};

export const sendMessage = ({ uuid, ...payload }) => {
  const url = `/core_sender/v1/sender_name/send_sms/${uuid}`;
  return service.post(url, payload);
};
